import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const fetchContactRequests = createAsyncThunk(
  "contactrequest/all-request",
  async () => {
    const response = await fetch(
      "https://joyfulserver.ddns.net:443/api/ContactRequest/all-contact-requests"
    );
    const result = await response.json();
    return result.data;
  }
);

export const addRequest = createAsyncThunk(
  "contactRequest/addRequest",
  async (newReq) => {
    const response = await fetch(
      "https://joyfulserver.ddns.net:443/api/ContactRequest/add-contact-request",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newReq),
      }
    );
    return await response.json();
  }
);

export const fetchContactRequestById = createAsyncThunk(
  "contactrequest/request-by-id",
  async (id) => {
    const response = await fetch(
      `https://joyfulserver.ddns.net:443/api/ContactRequest/contact-request-id/${id}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    const result = await response.json();
    return result.data;
  }
);

export const fetchContactRequestByName = createAsyncThunk(
  "contactrequest/request-by-name",
  async (name) => {
    const response = await fetch(
      `https://joyfulserver.ddns.net:443/api/ContactRequest/contact-request-name/${name}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    const result = await response.json();
    return result.data;
  }
);

export const fetchContactRequestByEmail = createAsyncThunk(
  "contactrequest/request-by-email",
  async (email) => {
    const response = await fetch(
      `https://joyfulserver.ddns.net:443/api/ContactRequest/contact-request-email/${email}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );
    const result = await response.json();
    return result.data;
  }
);


export const deleteRequest = createAsyncThunk(
    "contactrequest/delete-request",
    async (id) => {
      const response = await fetch(
        `https://joyfulserver.ddns.net:443/api/ContactRequest/delete-contact-request/${id}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      );
    }
  );

const contactRequestsSlice = createSlice({
  name: "contactRequests",
  initialState: {
    contactRequests: [],
    selectedRequest: null,
    status: "idle",
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchContactRequests.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchContactRequests.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.contactRequests = action.payload;
      })
      .addCase(fetchContactRequests.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(fetchContactRequestById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchContactRequestById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.selectedRequest = action.payload;
      })
      .addCase(fetchContactRequestById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(fetchContactRequestByName.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchContactRequestByName.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.selectedRequest = action.payload;
      })
      .addCase(fetchContactRequestByName.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(fetchContactRequestByEmail.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchContactRequestByEmail.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.selectedRequest = action.payload;
      })
      .addCase(fetchContactRequestByEmail.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(addRequest.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addRequest.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.contactRequests.push(action.payload);
      })
      .addCase(addRequest.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(deleteRequest.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.contactRequests = state.contactRequests.filter((pr) => pr.id !== action.payload);
      });
  },
});

export default contactRequestsSlice.reducer;
